import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-irregular-check-lined",
  "use": "rt-base-irregular-check-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-irregular-check-lined\"><path d=\"M429.451 873.184s111.602-209.368 239.806-390.606C768.407 342.845 892 220.636 892 220.636L866.175 151s-146.65 99.15-265.17 220.437c-120.364 123.592-213.058 269.32-213.058 269.32L206.247 475.2 132 552.214l297.451 320.97z\" p-id=\"2736\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/irregular-check-lined.svg
// module id = 1755
// module chunks = 137